import { render, staticRenderFns } from "./RecruiterQaAdminThread.vue?vue&type=template&id=62504f70&scoped=true"
import script from "./RecruiterQaAdminThread.vue?vue&type=script&lang=js"
export * from "./RecruiterQaAdminThread.vue?vue&type=script&lang=js"
import style0 from "./RecruiterQaAdminThread.vue?vue&type=style&index=0&id=62504f70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "62504f70",
  null
  
)

export default component.exports